import React from "react";
import { useParams, NavLink } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import FinalCTA from "../FinalCTA";

const projects = [
  {
    slug: "food-delivery",
    title: "Food Delivery App",
    category: "iOS Apps",
    image:
      "https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=1200&auto=format&fit=crop",
    description:
      "A modern food delivery platform with real-time tracking, secure payments and seamless ordering experience.",

    technologies: [
      "React Native",
      "Node.js",
      "MongoDB",
      "Firebase",
      "Stripe",
    ],

    features: [
      "Restaurant Listing",
      "Live Order Tracking",
      "Push Notifications",
      "Online Payments",
      "Ratings & Reviews",
      "Discount Coupons",
    ],

    stats: {
      downloads: "50K+",
      rating: "4.9",
      growth: "120%",
    },
  },

  {
    slug: "fitness-tracker",
    title: "Fitness Tracker",
    category: "Android Apps",
    image:
      "https://images.unsplash.com/photo-1576678927484-cc907957088c?q=80&w=1200&auto=format&fit=crop",
    description:
      "Track workouts, calories, heart rate and fitness goals with a powerful mobile experience.",

    technologies: [
      "Flutter",
      "Firebase",
      "Google Fit API",
      "Node.js",
    ],

    features: [
      "Workout Tracking",
      "Health Analytics",
      "Goal Management",
      "Smart Notifications",
      "Activity Reports",
      "Progress Dashboard",
    ],

    stats: {
      downloads: "80K+",
      rating: "4.8",
      growth: "140%",
    },
  },

  {
    slug: "shopping-app",
    title: "Shopping App",
    category: "E-Commerce",
     image:
            "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=1200&auto=format&fit=crop",
    description:
      "Complete eCommerce shopping application with payments, wishlist and order tracking.",

    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "Stripe",
      "AWS",
    ],

    features: [
      "Product Catalog",
      "Wishlist",
      "Cart System",
      "Payments",
      "Order Tracking",
      "User Dashboard",
    ],

    stats: {
      downloads: "120K+",
      rating: "4.9",
      growth: "180%",
    },
  },
];

const PortfolioDetails = () => {
  const { slug } = useParams();

  const project = projects.find((item) => item.slug === slug);

  if (!project) {
    return (
      <div style={{ padding: "150px 20px", textAlign: "center" }}>
        <h2>Project Not Found</h2>
      </div>
    );
  }

  return (
    <>
      <Header />
      {/* HERO */}
      <section className="project-hero">
        <div className="container-custom">

          <div className="hero-content">
            <span className="project-tag">
              {project.category}
            </span>

            <h1>{project.title}</h1>

            <p>{project.description}</p>

            <div className="hero-btns">
              <button>Live Preview</button>

              <NavLink
                to="/contactus"
                className="contact-btn"
              >
                Start Similar Project
              </NavLink>
            </div>
          </div>

          <div className="hero-image">
            <img
              src={project.image}
              alt={project.title}
            />
          </div>

        </div>
      </section>

      <FinalCTA />
      <Footer />
      <style>{`

      .container-custom{
        max-width:1300px;
        margin:auto;
        padding:0 20px;
      }

      .project-hero{
        padding:130px 0;
background:"linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)"
        color:#fff;
      }

      .project-hero .container-custom{
        display:grid;
        grid-template-columns:1fr 1fr;
        align-items:center;
        gap:70px;
      }

      .project-tag{
        display:inline-block;
        padding:10px 18px;
        background:rgba(232,33,42,.15);
        color:#ff5d66;
        border-radius:50px;
        margin-bottom:20px;
        font-weight:700;
      }

      .hero-content h1{
        font-size:70px;
        line-height:1.1;
        margin-bottom:20px;
        font-family:'Syne',sans-serif;
      }

      .hero-content p{
        font-size:18px;
        line-height:1.8;
        color:#666666;
      }

      .hero-btns{
        display:flex;
        gap:15px;
        margin-top:35px;
      }

      .hero-btns button,
      .contact-btn{
        padding:15px 28px;
        border-radius:14px;
        border:none;
        text-decoration:none;
        font-weight:700;
      }

      .hero-btns button{
        background:#E8212A;
        color:#fff;
      }

      .contact-btn{
        background:#fff;
        color:#111;
      }

      .hero-image img{
        width:100%;
        border-radius:30px;
        height:600px;
        object-fit:cover;
        box-shadow:
        0 30px 70px rgba(0,0,0,.4);
      }

      .overview-section,
      .features-section,
      .tech-section,
      .stats-section{
        padding:100px 0;
      }

      .section-title{
        text-align:center;
        margin-bottom:50px;
      }

      .section-title span{
        color:#E8212A;
        font-weight:700;
      }

      .section-title h2{
        margin-top:15px;
        font-size:50px;
        font-family:'Syne',sans-serif;
      }

      .overview-text{
        max-width:900px;
        margin:auto;
        text-align:center;
        line-height:2;
        color:#666;
        font-size:18px;
      }

      .features-grid{
        display:grid;
        grid-template-columns:
        repeat(auto-fit,minmax(250px,1fr));
        gap:25px;
      }

      .feature-card{
        background:#fff;
        border-radius:25px;
        padding:35px;
        text-align:center;
        box-shadow:
        0 10px 40px rgba(0,0,0,.07);
        transition:.4s;
      }

      .feature-card:hover{
        transform:translateY(-10px);
      }

      .feature-icon{
        width:70px;
        height:70px;
        background:#E8212A;
        color:#fff;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        margin:auto;
        font-size:28px;
      }

      .feature-card h4{
        margin-top:20px;
      }

      .tech-stack{
        display:flex;
        flex-wrap:wrap;
        justify-content:center;
        gap:15px;
      }

      .tech-stack span{
        background:#fff3f3;
        color:#E8212A;
        padding:14px 22px;
        border-radius:50px;
        font-weight:700;
      }

      .stats-grid{
        display:grid;
        grid-template-columns:
        repeat(3,1fr);
        gap:25px;
      }

      .stat-card{
        background:#fff;
        padding:50px;
        border-radius:25px;
        text-align:center;
        box-shadow:
        0 10px 40px rgba(0,0,0,.08);
      }

      .stat-card h2{
        color:#E8212A;
        font-size:60px;
      }

      .project-cta{
        padding:120px 20px;
        background:
        linear-gradient(
        135deg,
        #E8212A,
        #ff4d5a
        );
        text-align:center;
        color:#fff;
      }

      .project-cta h2{
        font-size:60px;
        font-family:'Syne',sans-serif;
      }

      .project-cta p{
        margin:20px 0 35px;
        font-size:18px;
      }

      .cta-btn{
        background:#fff;
        color:#111;
        text-decoration:none;
        padding:16px 30px;
        border-radius:14px;
        font-weight:700;
      }

      @media(max-width:991px){

        .project-hero .container-custom{
          grid-template-columns:1fr;
        }

        .hero-content h1{
          font-size:45px;
        }

        .hero-image img{
          height:400px;
        }

        .stats-grid{
          grid-template-columns:1fr;
        }

        .section-title h2{
          font-size:34px;
        }

        .project-cta h2{
          font-size:40px;
        }
      }

      `}</style>
    </>
  );
};

export default PortfolioDetails;